import request from '../../utils/request';
import options from './options';

const urlPath = (url, path) => `${url}${path}`;

export const getCalculatorsAcidity = filter => request.get({
    url: urlPath(options.apiUrl, filter)
});

export const getCalculatorsAcidityItem = id => request.get({
    url: urlPath(options.apiUrl, `${id}/`)
});